import { dockerToolInstance } from '@/shared/api/api-instances/docker-tool/api-instance';
import type {
  PageSettingsSchema,
  SettingResponse,
  SettingsRequest,
} from '../model/types';
import type { AxiosRequestConfig } from 'axios';

export class DockerToolSettingsApi {
  static getAllSettings(params = {}, options: AxiosRequestConfig = {}) {
    return dockerToolInstance.get<PageSettingsSchema>(`/settings`, {
      ...options,
      params,
    });
  }

  static getSettingById(setting_id: string, options: AxiosRequestConfig = {}) {
    return dockerToolInstance.get<SettingResponse>(
      `/settings/${setting_id}`,
      options,
    );
  }

  static editSetting(
    setting_id: string,
    payload: SettingsRequest,
    options: AxiosRequestConfig = {},
  ) {
    return dockerToolInstance.put<SettingResponse>(
      `/settings/${setting_id}`,
      payload,
      options,
    );
  }
}